import { useMatches } from 'react-router-dom';
import { PageTitle } from '@oysterjs/ui/page';
import { PageOutlet } from '@oysterjs/ui/navigation';
import { settingsPage, usePageHeading } from '~/components/navigation';
export {
  SettingsProfilePage,
  UserProducerInformationCreatePage,
  UserProducerInformationEditPage
} from './profile';
export { SettingsTeamsPage } from './teams';
export { SettingsUsagePage, SettingsUsageRoute } from './usage';
export { SettingsLimitsPage, SettingsLimitsRoute } from './limits';

/** Marks a Settings route whose page titles itself, as an editor with a way back does. */
export type SettingsRouteHandle = { ownPageTitle?: boolean };

export const SettingsPage = () => {
  const { title, description } = usePageHeading(settingsPage);
  const ownPageTitle = useMatches().some(
    (match) => (match.handle as SettingsRouteHandle | undefined)?.ownPageTitle
  );

  return ownPageTitle ? (
    <PageOutlet />
  ) : (
    <PageTitle eyebrow={settingsPage.name} title={title} description={description}>
      <PageOutlet />
    </PageTitle>
  );
};
